import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './auth-context';

/**
 * Current admin session. Reads the single `AuthProvider` mounted in App.tsx —
 * the session subscription, tab-focus re-validation and idle timeout all live
 * there once, however many components call this.
 */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return value;
}
